module.exports = __webpack_public_path__ + "img/logo.bb012144.png";